// extracted by mini-css-extract-plugin
export default {"container":"FontSelection_container__hh6S-"};